'use client';

import React, { useContext, useEffect, useState } from 'react';
import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

interface CustomClearRefinementsProps {
  excludedAttributes?: string[];
}

export default function CustomClearRefinements({
  excludedAttributes = [],
}: CustomClearRefinementsProps) {
  const { canRefine, refine } = useClearRefinements({
    excludedAttributes,
  });

  const [hasActiveFilters, setHasActiveFilters] = useState(false);

  const handleReset = () => {
    refine();
  };

  return (
    <button
      disabled={!canRefine && !hasActiveFilters}
      onClick={handleReset}
      className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition ${
        canRefine || hasActiveFilters
          ? 'bg-blue-50 text-blue-600 hover:bg-blue-100'
          : 'cursor-not-allowed bg-gray-100 text-gray-400'
      }`}
      aria-label="Réinitialiser les filtres"
    >
      Réinitialiser
    </button>
  );
}
